import { FulfilmentRequestsService } from 'src/app/angularJS/services/fulfilment/fulfilment.service';
import { VariantService } from 'src/app/angularJS/services/variant/variant.service';
import ITimePeriod = InterACT.Interfaces.ITimePeriod;
declare const c3;

const TODAY_PERIOD_NAME = 'TODAY';
const YESTERDAY_PERIOD_NAME = 'YESTERDAY';

/**
 * Provides a summary chart for Actora summary endpoints
 */
export class SummaryChartController {
  public static $inject = [
    '$scope',
    'fulfilmentRequestsService',
    '$timeout',
    '$translate',
    'variantService',
    '$q',
    'localStorageService'
  ];
  public fulfilmentFilters: any;
  public showFilter: boolean;
  public showDatePicker: boolean;
  public applyingFilter: boolean;
  public options: InterACT.Interfaces.ISummaryChart;
  public chartId: string;
  public selectedTimePeriod: ITimePeriod;
  public currentDate: Date;
  private timePeriods: ITimePeriod[];
  private chart: any;

  constructor(
    private $scope: ng.IScope,
    private fulfilmentRequestsService: FulfilmentRequestsService,
    private $timeout: ng.ITimeoutService,
    private $translate: ng.translate.ITranslateService,
    private variantService: VariantService,
    private $q: ng.IQService,
    private localStorage: ng.local.storage.ILocalStorageService) {
    this.fulfilmentFilters =
      {
        fromDate: undefined,
        toDate: undefined,
        toDateMax: undefined,
        fromDateMin: undefined,
        fromDateMax: undefined
      };
    this.options = this.$scope.vm.options;
    this.timePeriods = [
      this.getTimePeriodForToday(),
      this.getTimePeriodBackInTime(1,0),
      this.getTimePeriodBackInTime(7,0),
      this.getTimePeriodBackInTime(0,1),
      this.getTimePeriodBackInTime(0,3),
    ];

    this.$timeout(this.create, 0);

    if (this.localStorage.get(this.options.chartId) && JSON.parse(this.localStorage.get(this.options.chartId)) !== null) {
      this.timePeriods.forEach((period) => {
        if (period.name === JSON.parse(this.localStorage.get(this.options.chartId)).name) {
          this.selectedTimePeriod = period;
        }
        else{
          this.selectedTimePeriod = JSON.parse(this.localStorage.get(this.options.chartId));
        }
      });
    }
    else {
      this.selectedTimePeriod = this.timePeriods.find( defaultTimePeriod => {
        return defaultTimePeriod.name === this.$translate.instant(YESTERDAY_PERIOD_NAME) });
      this.localStorage.set(this.options.chartId, JSON.stringify(this.selectedTimePeriod));
    }
    this.applyFilter(true);
    this.options.chartFilterText = this.selectedTimePeriod.name;
    this.currentDate = new Date();
    this.fulfilmentFilters.toDateMax = new Date();
    this.fulfilmentFilters.fromDateMax = new Date();
  }

  /**
   * Toggles the filter card
   */
  public toggleFilter = () => {
    this.showFilter = !this.showFilter;
  }

  /**
   * Applies the chosen filter for a summary chart
   */
  public applyFilter = (isInitialLoad: boolean) => {
    this.applyingFilter = true;
    if (this.isCustomDateRangeSelected()) {
      this.selectedTimePeriod = this.getCustomTimePeriod();
    }
    const filter = {
      by: this.options.applyFilter,
      query: this.options.applyFilter === 'state.name' ? this.selectedTimePeriod.query : undefined
    };

    this.fulfilmentRequestsService.getFulfilmentRequestSummary(filter.by, filter.query).then((response) => {
     this.options.data = response;
      this.options.chartFilterText = this.selectedTimePeriod.name;
      this.create();

      if (!isInitialLoad) {
        this.toggleFilter();
      }

      this.applyingFilter = false;

      this.localStorage.set(this.options.chartId, JSON.stringify(this.selectedTimePeriod));
    });
  }

  /**
   * Determines if a word should be pluralised
   *
   * @param numberOfItems A number that determines if we should pluralise a word or not
   * @param translationKey the word that can be pluralised
   *
   * @returns A translation string
   */
  public pluralise = (numberOfItems: number, translationKey: string) => {
    if (numberOfItems) {
      if (numberOfItems === 1) {
        return translationKey;
      }
      else {
        return translationKey + 'S';
      } } }

  public showErrorMessage = () => {
      return this.$translate.instant('FULFILMENT_NO_DATA', {timePeriodName: this.selectedTimePeriod.name});
    }

  /**
   * Toggles the date picker
   */
  public toggleCustomRangeMenu = () => {
    this.showDatePicker = !this.showDatePicker;
  }

  /**
   * A method which is used to update max toDate.
   */
  public updateMaxToDate = () => {
    let fromDate = new Date(this.fulfilmentFilters.fromDate);
    this.fulfilmentFilters.toDateMax = new Date(new Date(fromDate).setMonth(fromDate.getMonth() + 3));

    if(new Date(this.fulfilmentFilters.toDateMax) > new Date(this.currentDate))
    {
      this.fulfilmentFilters.toDateMax = new Date(this.currentDate);
    }
  }

  /**
   * A method which is used to update max and min fromDate.
   */
  public updateFromDateMinMax = () => {
    let toDate = new Date(this.fulfilmentFilters.toDate);
    this.fulfilmentFilters.fromDateMin = new Date(new Date(toDate).setMonth(toDate.getMonth() - 3));
    this.fulfilmentFilters.fromDateMax = new Date(toDate);
  }

  /**
   * A method which is used to clear the custom date selection.
   */
  public clearDate(){
    this.fulfilmentFilters.fromDate = null;
    this.fulfilmentFilters.toDate = null;
    this.fulfilmentFilters.toDateMax = new Date();
    this.fulfilmentFilters.fromDateMin = null;
    this.fulfilmentFilters.fromDateMax = new Date();
  }

  /**
   * A method that returns the time period if custom time range is selected on UI.
   */
  private getCustomTimePeriod() {
    let periodName;
    let queryForCustom;
    let toDate;
    let fromDate;

    if (this.isCustomDateRangeSelected()) {
      toDate = new Date(this.currentDate).toISOString().substr(0,19) + 'Z';
      fromDate = new Date(this.fulfilmentFilters.fromDate).toISOString().substr(0,19) + 'Z';
    }
    periodName = this.fulfilmentFilters.fromDate.toString().substr(4,11) + ' - ' + this.currentDate.toString().substr(4,11);
    if (this.fulfilmentFilters.toDate) {
      toDate = moment(new Date(this.fulfilmentFilters.toDate)).add(1,'day').toISOString().substr(0,19) + 'Z';
      periodName = this.fulfilmentFilters.fromDate.toString().substr(4,11) + ' - ' + this.fulfilmentFilters.toDate.toString().substr(4,11);
    }
    queryForCustom = `state.timestamp >= ${fromDate} and state.timestamp <= ${toDate}`;
    const timePeriod: ITimePeriod = { name:periodName, query:queryForCustom };
    return timePeriod;
  }

  private isCustomDateRangeSelected()
  {
      return this.fulfilmentFilters.fromDate;
  }
  /**
   * Gets the fist timestamp of Today's Date in utc standard
   * @returns timestamp String
   */
  private getFirstTimeStampOfToday(){
    const firstTimeStampOfToday = `${moment().utc().startOf('day')
      .toISOString().substr(0,19)}Z`;
    return firstTimeStampOfToday;
  }

  /**
   * Gets a timestamp in utc standard by subtracting days and months
   * @param acountOfDays the number of days that will be subtracted from the moment
   * @param amountOfMonths the number of months that will be subtracted from the moment
   * @returns timestamp String
   */
  private getTimeStampBySubtracting(amountOfDays: number, amountOfMonths: number){
    const timeStamp = `${moment().subtract(amountOfDays, 'days').subtract(amountOfMonths,'months')
      .utc().startOf('day').toISOString().substr(0,19)}Z`;
    return timeStamp;
  }

  /**
   * Gets the period names translated
   * @amountOfDays the number of days that will be included in the period name
   * @amountOfMonths the number of months that will be included in the period name
   * @returns periodName String
   */
  private getPeriodName(amountOfDays: number, amountOfMonths: number){
    let periodName ;

    if ( amountOfDays == 1 && amountOfMonths == 0){
      periodName = this.$translate.instant(YESTERDAY_PERIOD_NAME);
    }
    else if ( amountOfDays != 0 && amountOfMonths == 0){
      periodName  = `${this.$translate.instant('LAST')} ${amountOfDays} ${this.$translate.instant(this.pluralise(amountOfDays, 'TIME_DETAIL.DAY'))}`;
    }
    else if ( amountOfMonths !=0 ){
      periodName  = `${this.$translate.instant('LAST')} ${amountOfMonths} ${this.$translate.instant(this.pluralise(amountOfMonths, 'TIME_DETAIL.MONTH'))}`;
    }
    return periodName;
  }

  /**
   * Generates the Timestamp Query for Today's time period
   * that will be used in HTTP Get Request towards Fulfillment Manager Service
   * @returns queryForToday String
   */
  private getTimeStampQueryForToday(){
    const firstTimeStampToday = this.getFirstTimeStampOfToday();
    const queryForToday = `state.timestamp >= ${firstTimeStampToday}`;
    return queryForToday;
  }

  /**
   * Generates the Timestamp Query for a chosen time period
   * that will be used in HTTP Get Request towards Fulfillment Manager Service
   * @returns timeStampQuery String
   */
  private getTimeStampQuery(amountOfDays: number, amountOfMonths: number){
    const initialTimeStamp = this.getTimeStampBySubtracting(amountOfDays, amountOfMonths);
    const endingTimeStamp = this.getFirstTimeStampOfToday();
    const timeStampQuery = `state.timestamp >= ${initialTimeStamp} and state.timestamp < ${endingTimeStamp}`;
    return timeStampQuery;
  }

  /**
   * Get time period instance for Today
   * @returns todayTimePeriod TimePeriod
   */
  private getTimePeriodForToday(){
    const periodName = this.$translate.instant(TODAY_PERIOD_NAME);
    const queryForToday = this.getTimeStampQueryForToday();
    const todayTimePeriod: ITimePeriod = { name:periodName, query:queryForToday };
    return todayTimePeriod;
  }

  /**
   * Get time period instance for a selected period
   * @returns timePeriod TimePeriod
   */
  private getTimePeriodBackInTime(amountOfDays: number, amountOfMonths: number){
    const periodName = this.getPeriodName(amountOfDays, amountOfMonths);
    const queryGoingBackInTime = this.getTimeStampQuery(amountOfDays, amountOfMonths);
    const timePeriod: ITimePeriod = { name:periodName, query:queryGoingBackInTime };
    return timePeriod;
  }

  /**
   * Gets the fluffy catalogue variant name
   *
   * @param catalogueVariantLink The link of the catalogue product variant we want to get the name for
   *
   * @returns A http promise
   */
  private getCatalogueVariantName = (catalogueVariantLink: string) => {
    const splitVariantLink = catalogueVariantLink.split('/');

    const [catalogueId, productId, variantId] = [
      splitVariantLink[1],
      splitVariantLink[3],
      splitVariantLink[5]
    ];

    return this.variantService.getVariant(catalogueId, parseInt(productId), parseInt(variantId));
  }

  /**
   * Populates the pie chart with relevant data
   *
   * @param data The data we wish to populate the pie chart with
   * @param completedPromises A list of promises ready to be resolved
   */
  private populatePieChart = (data, completedPromises) => {
    for (const catalogueVariantLink in data.summary.subGroups) {
      if (_.startsWith(catalogueVariantLink, 'catalogues/')) {
        completedPromises.push(this.getCatalogueVariantName(catalogueVariantLink));
      }
    }
  }

  /**
   * Populates the bar chart with relevant data
   *
   * @param chart The chart element we wish to append category groups too
   * @param data The data we wish to populate the pie chart with
   * @param categories A list of categories we want to group our results by in a bar chart
   */
  private generateBarChart = (chart, data, categories) => {
    chart.axis.x.categories = [];

    for (const key in data.summary.subGroups) {
      chart.data.columns[0].push(<any>data.summary.subGroups[key].total);

      for (const statusKey in categories) {
        if (statusKey === key && !_.includes(chart.axis.x.categories, categories[statusKey].name)) {
          chart.axis.x.categories.push(categories[statusKey].name);
        }
      }
    }

    this.chart = c3.generate(chart);
  }

  /**
   * Generates a pie chart with all the correct configuration settings
   *
   * @param data The data we wish to populate the pie chart with
   * @param completedPromises A list of resolved promises
   * @param chart The chart we wish to append our C3 chart too
   */
  private generatePieChart = (data, completedPromises, chart) => {
    this.populatePieChart(data, completedPromises);

    this.$q.all(completedPromises).then((results) => {
      const keys = Object.keys(data.summary.subGroups);

      chart.data.columns.shift();

      results.forEach((catalogue: any, index: number) => {
        const total = data.summary.subGroups[keys[index]].total.toString();
        chart.data.columns.push([catalogue.name, total]);
      });

      chart['pie'] = {
        label: {
          format: (value, ratio, id) => {
            return '';
          }
        }
      };

      this.chart = c3.generate(chart);
    });
  }

  /**
   * Used to create the C3 chart with the summary data provided
   */
  private create = () => {
    const { chartType, chartId, chartName, showLabels, bar, legend, axis, tooltip, categories, data } = this.options;

    this.chartId = chartId;

    const completedPromises = [];

    const chart = {
      data: {
        columns: [[chartName]],
        type: chartType,
        labels: showLabels,
        onclick: this.handleClick
      },
      onresized: () => {
        if (chartType === 'bar') {
          this.chart.destroy();
          this.create();
        }
      },
      bar: bar,
      legend: legend,
      axis: axis,
      tooltip: tooltip,
      bindto: `#${chartId}`
    };

    if (chartType === 'bar') {
      this.generateBarChart(chart, data, categories);
    } else if (chartType === 'pie') {
      this.generatePieChart(data, completedPromises, chart);
    } else {
      throw new Error('You must supply a valid chart type (Bar, Pie)');
    }

    this.setCategoryColours(this.generateColourPalette(), chartId);
    this.customStyling();
  }

  /**
   * A callback used in conjunction with C3's click handler
   * @param data The data object that gets returned by C3's click event
   */
  private handleClick = (data) => {
    let keys;
    if (this.options.chartType === 'pie') {
      keys = Object.keys(this.options.data.summary.subGroups).filter((key) => { return _.startsWith(key, 'catalogues/'); });
    } else {
      keys = Object.keys(this.options.data.summary.subGroups);
    }

    if (this.options.onClick) {
      this.options.onClick({
        data: this.options.data.summary.subGroups[keys[data.index]],
        keyName: keys[data.index],
        filterQuery: this.selectedTimePeriod.query.split('>=')[1]
      });
    }
  }

  /**
   * Generates a colour palette for a list of categories
   */
  private generateColourPalette = () => {
    const colours = [];

    if (!this.options.axis || !this.options.axis.x) {
      return;
    }

    this.options.axis.x.categories.forEach((category) => {
      for (const key in this.options.categories) {
        if (this.options.categories[key].name === category) {
          colours.push(this.options.categories[key].color);
        }
      }
    });

    return colours;
  }

  /**
   * Sets category colours for a chart
   * @param colors An array of colors for a category
   * @param chartContainer The id of the chart we want to manipulate
   */
  private setCategoryColours = (colors: Array<string>, chartContainer: string) => {
    $('#' + chartContainer + ' .c3-chart-bars .c3-shape').each(function (index) {
      this.style.cssText +=
        'fill: ' +
        colors[index] +
        ' !important; stroke: ' +
        colors[index] +
        '; !important';
    });

    $('#' + chartContainer + ' .c3-chart-texts .c3-text').each(function (index) {
      this.style.cssText += 'font-size: 12px !important; color: rgba(0, 0, 0, 0.54)!important;';
    });
  }

  /**
   * Applies custom styling for C3 charts
   */
  private customStyling = () => {
    $('.c3-axis-x > path').remove();

    $('.tick > line').remove();

    $('.tick > text > tspan').css({
      'font-size': '10px',
      color: 'rgba(0, 0, 0, 0.87)'
    });

    $('.c3-bars path').css({
      'stroke-width': '2px',
      'stroke-opacity': '1'
    });
  }
}
